import React, { useEffect, useState, useContext, useRef } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import { Link } from "react-router-dom";
import "../../../index.css";
import { numberFormat } from "../../../config/numberFormat";
import ToggleSwitch from "../../../_toggleSwitch/toggleSwitch";
import { PostData } from "../../../service/postData";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import QuickAdjustAddNewTerms from "../userExpense/quickAddTerms";
import QuickAddNewParty from "../businessParty/quickPartyAdd";
import QuickAddNewBankDetail from "../cashBank/quickBankAdd";
import QuickAddNewPrefix from "../userSale/quickNewPrefixAdd";
import { Loader } from "@progress/kendo-react-indicators";
import TransactionCreateDialog from "../TransactionCreateDialog";
import { useLocation, useHistory } from 'react-router-dom';
import QuickTransactionSaleInvoiceSection from "../userSale/QuickTransactionSaleInvoiceSection";

 
const ManagePurchaseReturnCreate = (props) => {
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const auth = queryParams.get('auth');
  const transactionType = queryParams.get('tType') ? queryParams.get('tType') : '';
  const isConvert = transactionType == 'DEBIT NOTE';
  const isDuplicate = transactionType == 'DUPLICATE';
  const [businessSetting, setBusinessSetting] = useState({});
  const [searchPartyName, setSearchPartyName] = useState('');
  const [partyId, setPartyId] = useState(0);
  const [partyName, setPartyName] = useState('');
  const [partyContactNo, setPartyContactNo] = useState('');
  const [partyRemainBalance, setPartyRemainBalance] = useState(0);
  const [billingName, setBillingName] = useState('');
  const [billingAddress, setBillingAddress] = useState('');
  const [poNumber, setPoNumber] = useState('');
  const [poDate, setPoDate] = useState(moment().format("YYYY-MM-DD"));
  const [EWayBillNo, setEWayBillNo] = useState('');
  const [paymentTermsData, setPaymentTermsData] = useState([]);
  const [dueOnDate, setDueOnDate] = useState(moment().format("YYYY-MM-DD"));
  const [termsId, setTermsId] = useState(0);
  const [prefixId, setPrefixId] = useState(1);
  const [prefixName, setPrefixName] = useState('');
  const [prefixArray, setPrefixArray] = useState([]);
  const [invoiceNo, setInvoiceNo] = useState(Math.floor(Math.pow(10, 5) + Math.random() * (Math.pow(10, 6) - Math.pow(10, 5) - 1)));
  const [invoiceNoReturn, setInvoiceNoReturn] = useState(Math.floor(Math.pow(10, 5) + Math.random() * (Math.pow(10, 6) - Math.pow(10, 5) - 1)));
  const [invoiceDate, setInvoiceDate] = useState(moment().format("YYYY-MM-DD"));
  const [invoiceDateReturn, setInvoiceDateReturn] = useState(moment().format("YYYY-MM-DD"));
  const [invoiceTime, setInvoiceTime] = useState(moment().format("hh:mm A"));
  const [stateArray, setStateArray] = useState([]);
  const [stateName, setStateName] = useState('');
  const [bankId, setBankId] = useState(-2);
  const [bankName, setBankName] = useState('');
  const [paymentType, setPaymentType] = useState('Cash');
  const [paymentRefNo, setPaymentRefNo] = useState('');
  const [description, setDescription] = useState('');
  const [descImage, setDescImage] = useState('');
  const refDescImage = useRef();
  const [imagePreviewUrl, setImagePreviewUrl] = useState('');
  const [transactionId, setTransactionId] = useState(0);
  const [printType, setPrintType] = useState('showall');
  const [reverseChargeStatus, setReverseChargeStatus] = useState(false);
  const [reverseChargeTax, setReverseChargeTax] = useState(0);
  const [transactionWiseTaxId, setTransactionWiseTaxId] = useState(0);
  const [totalTransTaxRatio, setTotalTransTaxRatio] = useState(0);
  const [totalTransTaxAmount, setTotalTransTaxAmount] = useState(0);
  const [transAdditionalCharge1, setTransAdditionalCharge1] = useState(0);
  const [transAdditionalCharge2, setTransAdditionalCharge2] = useState(0);
  const [transAdditionalCharge3, setTransAdditionalCharge3] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);
  const [subTotalAmount, setSubTotalAmount] = useState(0);
  const [receivedAmount, setReceivedAmount] = useState(0);
  const [dueAmount, setDueAmount] = useState(0);
  const [additionalValue1, setAdditionalValue1] = useState('');
  const [additionalValue2, setAdditionalValue2] = useState('');
  const [additionalValue3, setAdditionalValue3] = useState('');
  const [additionalValue4, setAdditionalValue4] = useState(moment().format("YYYY-MM-DD"));
  const [transportDetailField1, setTransportDetailField1] = useState('');
  const [transportDetailField2, setTransportDetailField2] = useState('');
  const [transportDetailField3, setTransportDetailField3] = useState('');
  const [transportDetailField4, setTransportDetailField4] = useState('');
  const [transportDetailField5, setTransportDetailField5] = useState('');
  const [transportDetailField6, setTransportDetailField6] = useState('');
  const [invoiceArray, setInvoiceArray] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState([]);
  const [partyArray, setPartyArray] = useState([]);
  const [bankArray, setBankArray] = useState([]);
  const [companyId, setCompanyId] = useState(0);
  const [businessId, setBusinessId] = useState(0);
  const [signingId, setSigningId] = useState(0);
  const [countryName, setCountryName] = useState('');
  const [showPartyViewList, setShowPartyViewList] = useState(false);
  const [isDialogOpen_Time, setIsDialogOpen_Time] = useState(false);
  const [isDialogOpen_AddPrefix, setIsDialogOpen_AddPrefix] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [message, setMessage] = useState('');
  const [printTypeList, setprintTypeList] = useState([]);
  const [isMakePayment, setIsMakePayment] = useState(false);
  const [isChequeMakePayment, setIsChequeMakePayment] = useState(false);
  const [isItemSoldOut, setIsItemSoldOut] = useState(false);
  const [totalLinkHistoryAmt, setTotalLinkHistoryAmt] = useState(0);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isDialogPreviewImage, setIsDialogPreviewImage] = useState(false);
  const [isDialogAddNewParty, setIsDialogAddNewPArty] = useState(false);
  const [isDialogAddNewBank, setIsDialogAddNewBank] = useState(false);

  const handleKeyPress = (e) => {
    if (!/[0-9.]/.test(e.key)) {
      e.preventDefault();
    }
    const currentValue = e.target.value;
    const dotCount = (currentValue.match(/\./g) || []).length;
    
    if (e.key === '.' && dotCount >= 1) {
      e.preventDefault();
    }
  };
  useEffect(() => {
    let dummyData = [
      { value: "showall", label: "Show All" },
      { value: "Original", label: "Original" },
      { value: "Duplicate", label: "Duplicate" },
      { value: "Triplicate", label: "Triplicate" },
    ]
    setprintTypeList(dummyData);
  }, []);

  useEffect(() => {
    let _UserSession = localStorage.getItem("vs_UserSession");

    // Parse before doing anything else — the previous code read
    // `_UserSession.loginType` off the JSON string (always undefined),
    // then called JSON.parse without a try/catch so a corrupt session
    // string (e.g. "null") would throw and abort the whole effect,
    // leaving the page with no data and no error surfaced.
    if (_UserSession) {
      try {
        _UserSession = JSON.parse(_UserSession);
      } catch (e) {
        _UserSession = null;
      }
    }
    if (_UserSession && _UserSession.loginType != "Admin") {
      {
        let _signingId = _UserSession.loginId;
        let _businessId = _UserSession.tokenKey;
        let _company_id = _UserSession.company_id;
        let _businessSetting = _UserSession.businessSetting || {};

        setSigningId(_signingId);
        setCompanyId(_company_id);
        setBusinessId(_businessId);
        setBusinessSetting(_businessSetting);

        if (_businessSetting.PrintOriginalDuplicate == 0) {
          setPrintType('');
        }
      }
    }
    let _companySession = localStorage.getItem("vs_UserCompanySession");
    if (_companySession) {
      try {
        _companySession = JSON.parse(_companySession);
      } catch (e) {
        _companySession = null;
      }
    }
    if (_companySession) {
      let _businessId = _companySession.business_id;
      let _company_id = _companySession.company_id;
      let _countryCode = _companySession.country_code;
      let _countryName = _companySession.country_name;


      setCompanyId(_company_id);
      setBusinessId(_businessId);
      setCountryName(_countryName);

      getPartyListData(_company_id);
      getStateListData(_countryCode);
      getBankListData(_company_id);
      getTransactionDetails(_company_id, _businessId);
      getPaymentTerms(_company_id, _businessId);
    }


  }, []);

  const getTransactionDetails = (company_id, businessId) => {
    if (auth) {
      setTransactionId(auth);
      setIsLoading(true);
      setIsEditMode(true);
      const requestData = JSON.stringify({
        transaction_id: auth,
      }); 
      PostData(isConvert ? global.userPurchaseTransactionDetails : global.userReturnTransactionDetails, requestData, "POST")
        .then((result) => {
          setIsLoading(false);
          let responseJson = result;
          if (responseJson.success) {
            // Any unguarded field access below throws inside this .then and
            // gets swallowed by .catch, leaving state partially populated —
            // subsequent render then hits a stale-state mismatch and blanks
            // the page. Guard the shape defensively so a sparse debit note
            // still renders.
            let response = (responseJson.response && responseJson.response[0]) || {};
            let totalSummary = response.totalSummary || {};
            let prefix = response.prefix || {};
            let customer = response.customer || {};

            setPartyId(customer.party_id || 0);
            setPartyName(customer.party_name || '');
            setPartyContactNo(customer.party_contact_no || '');
            setBillingName(customer.billing_name || '');
            setBillingAddress(response.billing_address || '');
            setPartyRemainBalance(customer.partyBalance || 0);
            setPoNumber(response.po_number || '');
            setPoDate(response.po_date ? response.po_date : moment().format("YYYY-MM-DD"));
            setDueOnDate(response.dueOnDate ? response.dueOnDate : moment().format("YYYY-MM-DD"));
            setTermsId(response.dueTerms || 0);
            setEWayBillNo(response.E_Way_Bill_No || '');


            setInvoiceTime(response.invoice_time || moment().format("hh:mm A"));
            setStateName(response.countryState || '');
            setTotalTransTaxAmount(response.totalTransTaxAmount || 0);
            setTransactionWiseTaxId(response.transactionWiseTaxId || 0);
            setTransAdditionalCharge1(response.TransAdditionalCharge1 || 0);
            setTransAdditionalCharge2(response.TransAdditionalCharge2 || 0);
            setTransAdditionalCharge3(response.TransAdditionalCharge3 || 0);
            setTotalAmount(parseFloat(totalSummary.totalAmount) || 0);
            setPayableAmount(parseFloat(totalSummary.payableAmount) || 0);
            setSubTotalAmount(parseFloat(totalSummary.subtotal) || 0);
            setTotalTransTaxRatio(totalSummary.gstRatio || 0);
            setTotalTransTaxAmount(parseFloat(totalSummary.gstAmount) || 0);
            setTotalQuantity(totalSummary.totalQty || 0);

            setReverseChargeStatus(!!totalSummary.reverseChargeStatus);
            setReverseChargeTax(totalSummary.reverseChargeTax || 0);
            setAdditionalValue1(response.additional_value_1 || '');
            setAdditionalValue2(response.additional_value_2 || '');
            setAdditionalValue3(response.additional_value_3 || '');
            setAdditionalValue4(response.additional_value_date || moment().format("YYYY-MM-DD"));
            setTransportDetailField1(response.TransportDetailField1 || '');
            setTransportDetailField2(response.TransportDetailField2 || '');
            setTransportDetailField3(response.TransportDetailField3 || '');
            setTransportDetailField4(response.TransportDetailField4 || '');
            setTransportDetailField5(response.TransportDetailField5 || '');
            setTransportDetailField6(response.TransportDetailField6 || '');
            setBankId(response.bankId != null ? response.bankId : -2);
            setBankName(response.bankName || '');
            setPaymentType(response.paymentType || 'Cash');
            setPaymentRefNo(response.paymentRefNo || '');
            setDescription(response.description || '');
            setImagePreviewUrl(response.descImage ? (response.urlImg + response.descImage) : '');
            setPrintType(response.settingType || 'showall');
            setIsMakePayment(!!response.isMakePayment);
            setIsChequeMakePayment(!!response.isChequeMakePayment);
            setTotalLinkHistoryAmt(response.totalLinkHistoryAmt || 0);

            if (customer.party_id) {
              getInvoiceListByParty(customer.party_id, company_id, response);
            }
            getBankListData(company_id);

            //let _dueAmount = totalSummary.dueAmount - totalSummary.totalPaidAmount;
            let _dueAmount = parseFloat(totalSummary.dueAmount) || 0; // partial purchase return pr correct h
            setDueAmount(roundToDecimalPlaces(_dueAmount));
            
            if(isConvert){
              getPrefixList(company_id, businessId);
              setReceivedAmount(parseFloat(totalSummary.paidAmount) || 0);
              // Guard against sparse response — result.response may be
              // undefined/null which would crash the spread + .map and
              // blank the page on convert.
              let _selectedInvoice = Array.isArray(result.response) ? [...result.response] : [];

                _selectedInvoice = _selectedInvoice.map((data) => {
                  const _items = Array.isArray(data.items) ? data.items : [];
                  return({
                    ...data,
                    isSelect: true,
                    invoice_no: data.invoiceNo,
                    items: _items.map((item) => ({
                      ...item,
                      isSelect: true,
                      newQuantity: item.quantity,
                      invoice_no: data.invoiceNo
                    }))
                  })
                });

                setInvoiceArray(Array.isArray(result.response) ? result.response : []);
                setSelectedInvoice(_selectedInvoice);

                // Check if any serial/batch items have been sold - prevent return for sold items
                let isItemSoldOutConvert = _selectedInvoice.some((data) =>
                  data.items.some((item) =>
                    item.selectedData && item.selectedData.some((selected) => selected.isSoldOut)
                  )
                );
                if(isItemSoldOutConvert){
                  alert('Some of these items have already been sold, so it cannot be returned. In order to proceed, the specific sale transaction would need to be deleted first.');
                }
                setIsItemSoldOut(isItemSoldOutConvert);

                let isDiscountInItem = _selectedInvoice.some(invoice =>
                  invoice.items.some(item => item.discount_in_amount > 0)
                );
                if(isDiscountInItem){
                  alert('The payment for this sale return has been paid. Please delete the linked transaction to make changes.');
                }
            }else{
              getPrefixList(company_id, businessId, prefix);
              setReceivedAmount(parseFloat(totalSummary.receivedAmount) || 0);
              setInvoiceNo(response.invoiceNo || '');
              setInvoiceDate(response.invoiceDate ? moment(response.invoiceDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"));
              setInvoiceNoReturn(response.invoice_no_return || '');
              setInvoiceDateReturn(response.invoice_date_return ? moment(response.invoice_date_return).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"));

              // Guard invoiceData / nested items / selectedData — any
              // missing branch would crash the sold-out check and blank
              // the edit page.
              const _invoiceData = Array.isArray(response.invoiceData) ? response.invoiceData : [];
              setSelectedInvoice(_invoiceData);
              let isItemSoldOut = _invoiceData.some((data) => (Array.isArray(data.items) ? data.items : []).some((item) => (Array.isArray(item.selectedData) ? item.selectedData : []).some((d) => d.isSoldOut)))
              if(isItemSoldOut){
                alert('Some of these items have already been sold, so it cannot be return . In order to proceed, the specific sale transaction would need to be deleted first.');
              }
              setIsItemSoldOut(isItemSoldOut);
            }
            if (response.isReturn) {
              alert('This transaction cannot be updated because it has a partial or full return. To edit it, delete the return associated with the transaction.');
            } else{
              if(isConvert){
                
              }else if(response.isMakePayment){
                alert('The payment for this purchase has been received. Please delete the linked transaction to make changes.');
              } else if(response.isChequeMakePayment){
                alert('This transaction cannot be edited because cheque associated with the transaction is already closed. Re-open the cheque to edit this transaction.');
              }
            }
            
          } else {
            alert("Transaction details not found in system.");
            setTimeout(() => {
              window.location.href = global.webUrl + "business/purchase-invoice/";
              return;
            }, Math.floor(Math.random() * 5000) + 1);
            //this.setState({unitArray:_unitArray,isLoaded:true});
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error('userReturnTransactionDetails failed:', error && error.message ? error.message : error);
        });

    }else{

      getPrefixList(company_id, businessId);
    }
  }

  const getPartyListData = (_company_id) => {

    let _url_GetData = global.userPartyList + "?company_id=" + _company_id;
    setIsLoading(true);
    PostData(_url_GetData, "", "GET")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {

        } else {
          let _partyBal = 0;
          if (responseJson.response) {
            let _partyArray = responseJson.response;
            setPartyArray(_partyArray);
            _partyArray.map((party, index) => {
              if (party.party_id == partyId) {
                _partyBal = party.totalOutCome;
              }
            });
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  const getInvoiceListByParty = (partyId, company_id, editData) => {
    setIsLoading(true);
    const requestData = JSON.stringify({
      company_id: company_id,
      partyId: partyId,
      type: "PURCHASE",
    });

    PostData(global.getPartyOldTransationData, requestData, "POST")
      .then((result) => {
        if (result.success == false) {
          if(!editData){
            setInvoiceArray([]);
            setSelectedInvoice([]);
            alert('No invoice available.');
          }else {
            let dataInvoice = editData.invoiceData.map((item) => {
              let items = item.items.map((data) => ({...data, isSelect: true}));

              return({
                ...item,
                isSelect: items.length > 0,
                items: [...items]
              })
            });
            setInvoiceArray(dataInvoice);
            setSelectedInvoice(dataInvoice);
          }
        } else {

          let data = result.response.map((item) => ({
            ...item,
            isSelect: false
          }))

          setInvoiceArray(data);

        }
        setIsLoading(false);
      })
      .catch((error) => setIsLoading(false));
  }

  const getPaymentTerms = (companyId, businessId) => {
        let dummyData = [{ "id": -1, "terms_name": "Add Terms", "terms_days": 0, "terms_default_status": 0 },
        { "id": 0, "terms_name": "Custom", "terms_days": 0, "terms_default_status": 0 }];
        const requestDueDateData = JSON.stringify({
          businessId: businessId,
          company_id: companyId,
        });
    
        PostData(global.businessDueDatePaymentTermList, requestDueDateData, "POST")
          .then((result) => {
            let responseJson = result;
            
            if (responseJson.success == false) {
              setPaymentTermsData([...dummyData]);
            } else {
              let _mainResponse = responseJson.response;
              setPaymentTermsData([...dummyData, ..._mainResponse]);
              if (!auth) {
                let terms = _mainResponse.find((data) => data.terms_default_status == 1);
                if (terms) {
                  setTermsId(terms.id);
                  setDueOnDate(moment(invoiceDate).add(terms.terms_days, 'days').format("YYYY-MM-DD"));
                }
              }
             
            }
          })
          .catch((error) => {
    
          });
    }
  
  const getPrefixList = (_company_id, _businessId, prefix) => {
    let dummyData = [{ "isSelected": false, "prefix_id": -1, "prefix": "Add Prefix", "prefix_type": "DEBIT NOTE" },
      { "isSelected": false, "prefix_id": 0, "prefix": "None", "prefix_type": "DEBIT NOTE" }];
    const requestData = JSON.stringify({
      company_id: _company_id,
      businessId: _businessId,
      type: "DEBIT NOTE",
    });
    PostData(global.businessWebPrefixList, requestData, "POST")
      .then(async (result) => {
        let responseJson = result;
        if (responseJson.success == false) {
          setPrefixArray([...dummyData]);
          setPrefixId(0);
          setPrefixName('None');
        } else {
          if (responseJson.response) {
            let _prefixArray = responseJson.response;
            _prefixArray = _prefixArray.filter(
              (itemData) => itemData.prefix != null
            );
            
            if(prefix && prefix.id){
              const prefixData = _prefixArray.filter((data) => data.prefix_id == prefix.id)
              setPrefixId(prefixData[0].prefix_id);
              setPrefixName(prefixData[0].prefix);
            }else{
              let _prefixSelData = _prefixArray.filter((item) => item.isSelected == true)
              let id = 0;
              let name = 'None';
              
              if(_prefixSelData.length === 0){
                dummyData = dummyData.map((data) => ({
                  ...data,
                  isSelected: data.prefix_id == 0
                }))
              }else{
                id = _prefixSelData[0].prefix_id;
                name = _prefixSelData[0].prefix;
              }
              setPrefixId(id);
              setPrefixName(name);
            }
            setPrefixArray([...dummyData, ..._prefixArray])
          }
        }
      })
      .catch((error) => {
        console.log('error', error);
       });
  }
  const getStateListData = (countryCode) => {
    let _url_GetData =
      global.adminStateList + "?countryCode=" + countryCode;
    PostData(_url_GetData, "", "GET")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {
        } else {
          if (responseJson.response) {
            let _stateArray = responseJson.response;
            setStateArray(_stateArray);
          }
        }
      })
      .catch((error) => { });
  }
  const getBankListData = (company_id) => {
    let dummyData = [{ id: "-1", bank_name: "Add Bank", paymentType: "" },
    { id: "-2", bank_name: "Cash", paymentType: "Cash" },
    { id: "-3", bank_name: "Cheque", paymentType: "Cheque" }]
    let _url_GetData = global.userBankDetailsList + "?company_id=" + company_id;
    PostData(_url_GetData, "", "GET")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {
          setBankArray([...dummyData]);
        } else {
          if (responseJson.response) {
            let _bankDetailArray = responseJson.response;
            setBankArray([...dummyData, ..._bankDetailArray]);
          }
        }
      })
      .catch((error) => { });
  }

 
  const getColorBal = () => {
    let _colorBal = "text-normal";
    if (partyRemainBalance < 0) {
      _colorBal = "text-danger";
    } else if (partyRemainBalance > 0) {
      _colorBal = "text-success";
    } else {
      _colorBal = "text-normal";
    }
    return _colorBal;
  }
  const onChangePartyName = (value) => {
    setSearchPartyName(value);
    setPartyId(0);
    setPartyName('');
  }
  const manageShowPartyFilter = () => {
    setPartyId(0);
    setPartyName('');
    setShowPartyViewList(true);
  }


  const viewPartyList = () => {
    let _colorVal = '';
    let data = partyArray.filter((data) => data.party_name.toLowerCase().includes(searchPartyName.toLowerCase())).map((party, i) => {
      let _balance = party.totalOutCome;
      if (_balance < 0) {
        _colorVal = "red";
      } else if (_balance == 0 || _balance == "0") {
        _colorVal = "black";
      } else {
        _colorVal = "green";
      }
      return (
        <li
          key={i}
          className="iti__party iti__standard"
          id="iti-item-in"
          onClick={() => selectPartiess(party)}
        >
          <span className="iti__party-name">{party.party_name}</span>
          <span className="iti__party-balance" style={{ color: _colorVal }}>
            {numberFormat(Math.abs(_balance))}
          </span>
        </li>
      );
    });
    return data;
  }
  const selectPartiess = (party) => {
    setSearchPartyName('');
    setPartyId(party.party_id);
    setPartyName(party.party_name);
    setPartyRemainBalance(party.totalOutCome);
    setPartyContactNo(party.party_contact_no);
    setBillingName(party.billing_name);
    setBillingAddress(party.party_billing_address);
    setStateName(party.countryState);
    setShowPartyViewList(false);
    getInvoiceListByParty(party.party_id, companyId);
  }

  const selectPrefix = (e) => {
    let value = e.target.value;
    if (value == -1) {
      setIsDialogOpen_AddPrefix(true);
    } else {
      let prefixData = prefixArray.filter((data) => data.prefix_id == value)[0];
      setPrefixId(prefixData.prefix_id);
      setPrefixName(prefixData.prefix);
    }
  }
  const handleCallBackInvoiceDate = (date) => {
    date = moment(date).format("YYYY-MM-DD")
    setInvoiceDateReturn(date);
    if (termsId > 0) {
      let patmentData = paymentTermsData.filter((data) => data.id == termsId)[0];
      let newDueDate = moment(date).add(patmentData.terms_days, "days").format("YYYY-MM-DD");
      setDueOnDate(newDueDate);
    }
  };
  const viewInvoiceDate = () => {
    const slectedDate = moment(invoiceDateReturn).toDate();
    return (
      <DatePicker
        selected={slectedDate}
        disabled={isDuplicate}
        className="form-control search-box"
        onChange={date => handleCallBackInvoiceDate(date)}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
      />
    );
  }
  const handleCallBackAdditionalValue4Date = (date) => {
    setAdditionalValue4(moment(date).format("YYYY-MM-DD"));
  };
  const viewAdditionalDate = () => {
    const slectedDate = moment(additionalValue4).toDate();
    return (
      <DatePicker
        selected={slectedDate}
        disabled={isDuplicate}
        className="form-control search-box"
        onChange={date => handleCallBackAdditionalValue4Date(date)}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
      />
    );
  }
  const onMouseLeaveHandlerTime = () => {

  }
  const onMouseLeaveHandler = () => {

  }
  const generateTimeSlots = (interval = 1) => {
    const slots = [];
    const start = new Date(); // Start from current time
    start.setSeconds(0, 0); // Round down to the nearest hour

    for (let i = 0; i < 24 * 60 / interval; i++) {
      start.setMinutes(start.getMinutes() + interval);
      //slots.push(formatTime(new Date(start)));
      slots.push(moment(start).format("hh:mm A"));
    }

    return slots;
  };
  const availableTimeSlots = generateTimeSlots();
  const getTimeSlotList = () => {
    return availableTimeSlots.map((time, index) => (
      <div
        key={index}
        className="dropdown-item"
        onClick={() => {
          setIsDialogOpen_Time(false);
          setInvoiceTime(time);
        }}
      >
        {time}
      </div>
    ))
  }

  const selectBank = (e) => {
    let value = e.target.value;
    if (value == -1) {
      setIsDialogAddNewBank(true);
    } else {
      let bankData = bankArray.filter((data) => data.id == value)[0];
      setBankId(value);
      setBankName(bankData.bank_name ? bankData.bank_name : bankData.display_name);
      setPaymentType(bankData.paymentType);
    }
  }
  const onChangeFileUploadHandler = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      const validImageTypes = ['image/jpeg', 'image/png'];
        if (validImageTypes.includes(file.type)) {
          setDescImage(file);
          setImagePreviewUrl(reader.result);
        }else{
          e.target.value = '';
          alert('Please select a valid image file (JPEG, PNG, GIF).');
          return
        }
    };
    reader.readAsDataURL(file);
  }
  
  const previewImagesListing = () => {
    let dataList = [];
    let _imageDetails = imagePreviewUrl;
    if (_imageDetails != "") {
      dataList.push(
        <>
        <img
          style={{ width: "50px", height: '50px' }}
          className="preview"
          src={_imageDetails}
          alt={"image-"}
          key="13213"
        />
        <button
        style={{marginLeft: 10}}
            className="btn btn-info"
            onClick={() => {
              setIsDialogPreviewImage(true);
            }}
        >
            <i className="fa fa-eye" title="Preview"></i>
        </button>
        <button
        style={{marginLeft: 10}}
            className="btn btn-info"
            onClick={() => {
              refDescImage.current.value = '';
              setDescImage('');
              setImagePreviewUrl('');
            }}
        >
            <i className="fa fa-trash" title="Delete"></i>
        </button>
        </>
      );
    }
    return dataList;
  }
  const roundToDecimalPlaces = (value) => {
    value = parseFloat(value);
    value = isNaN(value) ? 0 : parseFloat(value.toFixed(2));
    return value;
  };

  const onCallbackAddPrefix = (id, name) => {
    setIsDialogOpen_AddPrefix(false);
    setPrefixId(id);
    setPrefixName(name);
    getPrefixList(companyId, businessId);
  }

  
  const onChangeAdditionalCharge1 = (value) => {
    value = value * 1;
    setTransAdditionalCharge1(value);
    let _totalAmount = subTotalAmount;
    _totalAmount = _totalAmount + totalTransTaxAmount + value + transAdditionalCharge2 + transAdditionalCharge3;
    setTotalAmount(roundToDecimalPlaces(_totalAmount));

    let payableAmount = _totalAmount > reverseChargeTax ? _totalAmount - reverseChargeTax : 0;
    setPayableAmount(roundToDecimalPlaces(payableAmount));

    let dueAmount = payableAmount - receivedAmount;
    setDueAmount(roundToDecimalPlaces(dueAmount));
  }
  const onChangeAdditionalCharge2 = (value) => {
    value = value * 1;
    setTransAdditionalCharge2(value);
    let _totalAmount = subTotalAmount;
    _totalAmount = _totalAmount + totalTransTaxAmount + transAdditionalCharge1 + value + transAdditionalCharge3;
    setTotalAmount(roundToDecimalPlaces(_totalAmount));

    let payableAmount = _totalAmount > reverseChargeTax ? _totalAmount - reverseChargeTax : 0;
    setPayableAmount(roundToDecimalPlaces(payableAmount));

    let dueAmount = payableAmount - receivedAmount;
    setDueAmount(roundToDecimalPlaces(dueAmount));
  }
  const onChangeAdditionalCharge3 = (value) => {
    value = value * 1;
    setTransAdditionalCharge3(value);
    let _totalAmount = subTotalAmount;
    _totalAmount = _totalAmount + totalTransTaxAmount + transAdditionalCharge1 + transAdditionalCharge2 + value;
    setTotalAmount(roundToDecimalPlaces(_totalAmount));

    let payableAmount = _totalAmount > reverseChargeTax ? _totalAmount - reverseChargeTax : 0;
    setPayableAmount(roundToDecimalPlaces(payableAmount));

    let dueAmount = payableAmount - receivedAmount;
    setDueAmount(roundToDecimalPlaces(dueAmount));
  }
  const onChangeReceivedAmount = (value) => {
    let newValue = value;
    newValue = newValue.replace(/[^0-9.-]/g, '');

    if ((newValue.match(/\./g) || []).length > 1) {
      newValue = newValue.slice(0, -1);
    }
    if(newValue > payableAmount){
      return;
    }
    
    setReceivedAmount(newValue);

    let _totalAmount = payableAmount - newValue;
    setDueAmount(roundToDecimalPlaces(_totalAmount));
  }
  
  const getPriceWithTaxWithOutTax = (sale_tax_type, ratio, price) => {
    if (sale_tax_type == 'With Tax') {
        price = (price / (100 + ratio)) * 100;
    }
    return price;
  }
  const callBack = async (invoice, subTotalAmount) => {
    console.log('callBack invoice', JSON.stringify(invoice));
    setSubTotalAmount(subTotalAmount);
    let totalQuantity = 0;
    let itemSubtotal = 0;
    let totalAllQuantity = 0;
    let receivedAmount = 0;
    let totalPaidAmount = 0;
    let totalTransTaxRatio = 0;
    let transactionWiseTaxId = 0;
    let totalItemTaxAmount = 0;
    let totalItemTaxRatio = 0;
    let items = [];
    let allItems = [];
    let _transAdditionalCharge1 = 0;
    let _transAdditionalCharge2 = 0;
    let _transAdditionalCharge3 = 0;
    let reverseChargeStatus = false;

    let _invoice = invoice.map((data) => {
      setInvoiceNo(data.invoice_no);
      setInvoiceDate(data.invoiceDate);
      let SelectedQty = 0;
      let qty = 0;
      data.items.filter((data) => data.isSelect).map((item) => {
        SelectedQty += item.newQuantity ? parseInt(item.newQuantity) : 0
      });
      data.items.map((item) => {
        qty += item.quantity ? parseInt(item.quantity) : 0
      });
      let totalSummary = {...data.totalSummary};
      totalSummary.subtotal = subTotalAmount;
      totalSummary.totalSelectedInvQty = SelectedQty;
      totalSummary.totalQty = qty;

      reverseChargeStatus = totalSummary.reverseChargeStatus == 1;
      
      let innerItem = data.items.filter((data) => data.isSelect);
      let innerAllItem = data.items;
      items = [...items, ...innerItem];
      allItems = [...allItems, ...innerAllItem];

      totalTransTaxRatio += parseFloat(totalSummary.gstRatio);
      receivedAmount += parseFloat(totalSummary.receivedAmount);
      totalPaidAmount += parseFloat(totalSummary.totalPaidAmount);
      
      _transAdditionalCharge1 += data.TransAdditionalCharge1 ? parseFloat(data.TransAdditionalCharge1) : parseFloat(transAdditionalCharge1);
      _transAdditionalCharge2 += data.TransAdditionalCharge2 ? parseFloat(data.TransAdditionalCharge2) : parseFloat(transAdditionalCharge2);
      _transAdditionalCharge3 += data.TransAdditionalCharge3 ? parseFloat(data.TransAdditionalCharge3) : parseFloat(transAdditionalCharge3);


      return({
        ...data,
        totalSummary: totalSummary
      })
    });

    allItems.map((item) => {
      totalAllQuantity += parseFloat(item.newQuantity);
    });
    items.map((item) => {
      let price = getPriceWithTaxWithOutTax(item.sale_tax_type, parseInt(item.tax_type.ratio), item.rate);
      let sub_total_amount = (item.newQuantity * price);
      itemSubtotal += parseFloat(sub_total_amount);
      totalQuantity += parseFloat(item.newQuantity);
      
      totalItemTaxRatio += item.tax_type.ratio ? parseFloat(item.tax_type.ratio) : 0;
      totalItemTaxAmount += parseFloat(item.tax_value);
    });
    setSelectedInvoice(_invoice);
    setTotalQuantity(totalQuantity);
    setReverseChargeStatus(reverseChargeStatus);
    setTransactionWiseTaxId(transactionWiseTaxId);
    setTransAdditionalCharge1(_transAdditionalCharge1);
    setTransAdditionalCharge2(_transAdditionalCharge2);
    setTransAdditionalCharge3(_transAdditionalCharge3);

    let _taxAmount = (totalTransTaxRatio / 100) * subTotalAmount;
    _taxAmount = roundToDecimalPlaces(_taxAmount);
    
    let _taxItemAmount = (totalItemTaxRatio / 100) * itemSubtotal;
    _taxItemAmount = roundToDecimalPlaces(_taxItemAmount);
    
    let totalAmount = subTotalAmount + (_taxAmount + _transAdditionalCharge1 + _transAdditionalCharge2 + _transAdditionalCharge3);
    
    setTotalTransTaxRatio(totalTransTaxRatio);
    setTotalTransTaxAmount(_taxAmount);
    setTotalAmount(roundToDecimalPlaces(totalAmount));

    let reverseChargeTax = reverseChargeStatus ? (_taxItemAmount + _taxAmount) : 0;
    setReverseChargeTax(reverseChargeTax);
    
    let payableAmount = totalAmount > 0 ? (totalAmount - reverseChargeTax) : 0;
    setPayableAmount(roundToDecimalPlaces(payableAmount));

    // For Purchase Return, set receivedAmount to 0 (vendor hasn't paid back yet for this return)
    // Don't include totalPaidAmount from original purchase - that's separate
    setReceivedAmount(0);
    let _dueAmount = payableAmount;

    setDueAmount(roundToDecimalPlaces(_dueAmount));
    
    //setDueAmount(isMakePayment ? dueAmount : roundToDecimalPlaces(totalAmount));
  }
  

  const clickToAddPurchaseReturn = () => {
    if (selectedInvoice.length <= 0) {
      alert('Please select at least one invoice.');
    } else if (selectedInvoice.filter((data) => parseInt(data.rate) == 0).length > 0) {
      alert('Price/Unit must be greater than 0.');
    } else if (dueAmount < 0) {
      alert('Due amount cannot be less than 0.');
    } else if (bankId == 0) {
      alert('Please select payment type like (Cash, Cheque or any bank.)');
    } else if(isItemSoldOut){
      alert('Some of these items have already been sold, so it cannot be return . In order to proceed, the specific sale transaction would need to be deleted first.');
    }else {
      if(isConvert){
        let isDiscountInItem = selectedInvoice.some(invoice => 
          invoice.items.some(item => item.discount_in_amount > 0)
        );
        if(isDiscountInItem){
          alert('The payment for this sale return has been paid. Please delete the linked transaction to make changes.');
          return;
        }
      } else if (isMakePayment) {
        alert('The payment for this invoice has been received. Please delete the linked transaction to make changes.');
        return;
      } else if(isChequeMakePayment){
        alert('This transaction cannot be edited because cheque associated with the transaction is already closed. Re-open the cheque to edit this transaction.');
        return;
      }
      setIsLoading(true);

      // let items = [];
      // selectedInvoice.map((data) => {
      //   let innerItem = data.items.filter((data) => data.isSelect);
      //   items = [...items, ...innerItem];
      // });
      
      const selectedItems = selectedInvoice.flatMap(invoice => 
        invoice.items.filter(item => item.isSelect)
      );
      const _selectedInvoice = selectedInvoice.map((invoice) => ({
        ...invoice,
        items: selectedItems
      }));
      
      let customer = {
        party_id: partyId,
        party_name: partyName,
        party_contact_no: partyContactNo,
        party_opening_balance: partyRemainBalance,
        billing_name: billingName,
      };
      let prefix = {
        name: prefixName,
        id: prefixId,
        isActive: "1",
      };
      let totalSummary = {
        subtotal: subTotalAmount,
        gstRatio: totalTransTaxRatio,
        gstAmount: totalTransTaxAmount,
        totalQty: totalQuantity,
        totalAmount: totalAmount ? totalAmount : 0,
        payableAmount: payableAmount ? payableAmount : 0,
        receivedAmount: receivedAmount ? parseFloat(receivedAmount) : 0,
        dueAmount:  dueAmount ? dueAmount : 0,
        totalDiscount: 0,
        reverseChargeTax: reverseChargeTax,
        reverseChargeStatus: reverseChargeStatus
      };
      let transactionWiseAmount = {
        transactionWiseTaxId: transactionWiseTaxId,
        totalTransTaxAmount: totalTransTaxAmount,
        totalTransDiscountPer: 0,
        totalTransDiscountAmount: 0,
      };
      let transactionAdditionalCharge = {
        TransAdditionalCharge1: transAdditionalCharge1,
        TransAdditionalCharge2: transAdditionalCharge2,
        TransAdditionalCharge3: transAdditionalCharge3,
      };
      let transacTransportationDetails = {
        TransportDetailField1: transportDetailField1,
        TransportDetailField2: transportDetailField2,
        TransportDetailField3: transportDetailField3,
        TransportDetailField4: transportDetailField4,
        TransportDetailField5: transportDetailField5,
        TransportDetailField6: transportDetailField6,
      };
      let purchaseData = new FormData();
      purchaseData.append("transaction_id", transactionId);
      purchaseData.append("business_id", businessId);
      purchaseData.append("user_id", signingId);
      purchaseData.append("company_id", companyId);
      purchaseData.append("customer", JSON.stringify(customer));
      purchaseData.append("billing_address", billingAddress);
      purchaseData.append("poNumber", poNumber);
      purchaseData.append("poDate", poDate);
      purchaseData.append("dueOnDate", dueOnDate);
      purchaseData.append("dueTerms", termsId);
      purchaseData.append("E_Way_Bill_No", EWayBillNo);
      purchaseData.append("prefix", JSON.stringify(prefix));
      purchaseData.append("invoiceNo", invoiceNo);
      purchaseData.append("invoiceDate", invoiceDate);
      purchaseData.append("invoiceNoReturn", invoiceNoReturn);
      purchaseData.append("invoiceDateReturn", invoiceDateReturn);
      purchaseData.append("invoiceTime", invoiceTime);
      purchaseData.append("selectedCountry", countryName);
      purchaseData.append("countryState", stateName);
      purchaseData.append("invoiceData", JSON.stringify(_selectedInvoice));
      purchaseData.append("items", JSON.stringify(selectedItems));
      purchaseData.append("totalSummary", JSON.stringify(totalSummary));
      purchaseData.append("transactionWiseAmount", JSON.stringify(transactionWiseAmount));
      purchaseData.append("transactionAdditionalCharge", JSON.stringify(transactionAdditionalCharge));
      purchaseData.append("additional_value_1", additionalValue1);
      purchaseData.append("additional_value_2", additionalValue2);
      purchaseData.append("additional_value_3", additionalValue3);
      purchaseData.append("additional_value_date", additionalValue4);
      purchaseData.append("bankId", bankId);
      purchaseData.append("bankName", bankName);
      purchaseData.append("paymentType", paymentType);
      purchaseData.append("paymentRefNo", paymentRefNo);
      purchaseData.append("description", description);
      purchaseData.append("descImage", descImage);
      purchaseData.append("settingType", printType);
      purchaseData.append("transactionTransportationDetails", JSON.stringify(transacTransportationDetails));

      if (isEditMode) {
        purchaseData.append("isMakePayment", isMakePayment);
        purchaseData.append("totalLinkHistoryAmt", totalLinkHistoryAmt);
      }
      if (isConvert) {
        purchaseData.append("sendUrlType", transactionType);
      }

      const formObject = {};
      purchaseData.forEach((value, key) => {
        if (key == 'customer' || key == 'prefix' || key == 'invoiceData' || key == 'items' || key == 'totalSummary' || key == 'transactionWiseAmount' || key == 'transactionAdditionalCharge' | key == 'transactionTransportationDetails') {
          value = JSON.parse(value);
        }
        formObject[key] = value;
      });
      console.log('formObject', JSON.stringify(formObject));
      //setIsLoading(false); return;
      let url = isConvert ? global.createPurchaseReturnTransaction : (isEditMode ? global.editPurchaseReturnTransaction : global.createPurchaseReturnTransaction);
      console.log('url', url);
      fetch(url, {
        method: "POST",
        body: purchaseData,
      })
        .then((response) => response.json())
        .then((res) => {
          setIsLoading(false);
          console.log('res', JSON.stringify(res));
          if (res.success == true) {
            setTransactionId(res.transaction_Id);
            setShowSuccessDialog(true);
          } else {
            console.log('res.message', res.message)
            alert(res.message);
          }
          setMessage(res.message);
        })
        .catch((error) => {
          console.log('error', error);
          setIsLoading(false);
        });

    }
  }

  return (
    <div className="">
      <div className="content">
        <div className="content-header">
          <div className="header-section">
            {/* <h2 className="content-heading">Manage Business</h2> */}
            <h1 className="content-heading">
              <i className="gi gi-direction"></i>Add / Edit Debit Note / Purchase Return
              <br />
            </h1>
          </div>
        </div>
        <nav className="breadcrumb push">
          <Link className="breadcrumb-item" to={"/business/dashboard/"}>
            Dashboard
          </Link>
          <Link className="breadcrumb-item" to={"/business/manage-purchase-return/"}>
            Manage Debit Note / Purchase Return List
          </Link>
          <span className="breadcrumb-item active">
            Add / Edit Debit Note / Purchase Return
          </span>
          <Link
            className="breadcrumb-item"
            to={"/business/add-purchase-debit-note/"}
            target="_blank"
          >
            <i className="fa fa-plus"> (Add More)</i>
          </Link>
        </nav>
        <div className="block ">
          <div className="row">
            <div className="col-md-6">
              <div className="block block-transparent">
                <div className="block-content" id="formSideLeft">
                  <div className="form-group row">
                    <div className="col-6">
                      <div
                        className="form-material open"
                        onMouseLeave={() => onMouseLeaveHandler()}
                      >
                        <input
                          // QA (2026-09-18): editing a DN and removing every
                          // linked bill left Party greyed out. The
                          // `isEditMode ||` OR clause overrode the more specific
                          // selectedInvoice guard so any edit kept the field
                          // locked regardless of whether a bill was still
                          // attached. Match the readOnly attribute's shape
                          // (which already keys off selectedInvoice only) —
                          // Party becomes editable once no bill is attached.
                          // Same fix already applied on the mobile sibling
                          // CreatePurchaseReturn.js.
                          disabled={selectedInvoice.length > 0}
                          readOnly={selectedInvoice.length > 0}
                          type="text"
                          className="form-control search-box"
                          onChange={(e) => onChangePartyName(e.target.value)}
                          onClick={() => manageShowPartyFilter()}
                          onBlur={() => partyName && setShowPartyViewList(false)}
                          placeholder="Search Party Name Here..."
                          autoComplete="off"
                          name="party_name"
                          id="party_name"
                          value={partyName ? partyName : searchPartyName}
                        />
                        <label htmlFor="login-username">
                          Party Name <span className="text-danger">*</span>
                        </label>
                        {
                          showPartyViewList &&
                          <ul
                            className={" iti__party-list iti__party-list--dropup"
                            }
                            id="country-listbox"
                            aria-expanded="false"
                            role="listbox"
                            aria-activedescendant="iti-item-ad"
                          >
                            <li
                              key={-1}
                              id="iti-item-in"
                              className="iti__party iti__standard"
                              style={{fontWeight: 'bold'}}
                              onClick={() => {setIsDialogAddNewPArty(true)}}
                            >
                              <span className="iti__party-name">{'Add New Party'}</span>
                            </li>
                            {viewPartyList()}
                          </ul>
                        }
                        <div className={getColorBal() + ' '}>
                          {partyName != ""
                            ? "Bal : " +
                            numberFormat(
                              Math.abs(partyRemainBalance)
                            )
                            : ""}
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-material open">
                        <input
                          type="text"
                          className="form-control search-box"
                          placeholder="Phone Number"
                          autoComplete="off"
                          value={partyContactNo}
                          disabled={isDuplicate}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^[0-9]*$/.test(value)) {
                              setPartyContactNo(value);
                            }
                          }}
                          maxLength="13"
                        />
                        <label htmlFor="login-username">Phone Number</label>

                      </div>
                    </div>
                    {businessSetting.Tran_BillingNameParty == 1 && (
                      <div className="col-6">
                        <div className="form-material open">
                          <input
                            type="text"
                            className="form-control search-box"
                            placeholder="Billing Name Here..."
                            autoComplete="off"
                            value={billingName}
                            disabled={isDuplicate}
                            onChange={(e) => {
                              const value = e.target.value;
                              setBillingName(value);
                            }}
                          />
                          <label htmlFor="login-username">Billing Name</label>
                        </div>
                      </div>
                    )}
                    {businessSetting.Tran_BillingNameParty == 1 && (
                      <div className="col-6">
                        <div className="form-material open">
                          <input
                            type="text"
                            className="form-control search-box"
                            placeholder="Billing Address Here..."
                            autoComplete="off"
                            value={billingAddress}
                            disabled={isDuplicate}
                            onChange={(e) => {
                              const value = e.target.value;
                              setBillingAddress(value);
                            }}
                          />
                          <label htmlFor="login-username">Billing Address</label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="block block-transparent">
                <div className="block-content">
                  <div className="" id="formSideRight">
                    {businessSetting.InvoiceBillNo == 1 && (
                      <div className="form-group row">
                        <label
                          style={{ textAlign: "right" }}
                          className="col-lg-4 col-form-label"
                          htmlFor="val-username"
                        >
                          Return No. <span className="text-danger">*</span>
                        </label>
                        <div
                          className="col-lg-3 form-material"
                          id="paddingOff"
                        >

                          <select
                            className="form-control "
                            required="required"
                            onChange={(e) => selectPrefix(e)}
                            value={prefixId}
                            disabled={isDuplicate}
                          >

                            {prefixArray.map(
                              (prefixData, index) => {

                                return (
                                  <option
                                    key={index}
                                    value={prefixData.prefix_id}
                                  >
                                    {prefixData.prefix}
                                  </option>
                                );
                              }
                            )}
                          </select>
                        </div>
                        &nbsp;&nbsp;&nbsp;
                        <div
                          className="col-lg-4 form-material"
                          id="paddingOff"
                        >
                          <input
                            type="text"
                            className="form-control"
                            required="required"
                            maxLength="20"
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^[0-9]*$/.test(value)) {
                                setInvoiceNoReturn(value);
                              }
                            }}
                            placeholder="Enter a Invoice No."
                            autoComplete="off"
                            value={invoiceNoReturn}
                          />

                        </div>
                      </div>
                    )}

                    <div className="form-group row">
                      <label
                        style={{ textAlign: "right" }}
                        className="col-lg-4 col-form-label"
                        htmlFor="val-username"
                      >
                        Return Date <span className="text-danger">*</span>
                      </label>

                      <div className="col-lg-8 form-material" id="paddingOff">
                        {viewInvoiceDate()}
                      </div>
                    </div>
                    {businessSetting.Tran_AddTime == 1 && (
                      <div className="form-group row">
                        <label
                          style={{ textAlign: "right" }}
                          className="col-lg-4 col-form-label"
                          htmlFor="val-username"
                        >
                          Time
                        </label>
                        <div
                          className="col-lg-8 form-material"
                          id="paddingOff"
                          onMouseLeave={() => onMouseLeaveHandlerTime()}
                        >
                          <input
                            readOnly="readOnly"
                            type="text"
                            className="form-control search-box"
                            onClick={() => setIsDialogOpen_Time(true)}
                            placeholder="Please Select Time"
                            autoComplete="off"
                            name="invoiceTime"
                            id="invoiceTime"
                            value={invoiceTime}
                            disabled={isDuplicate}
                          />
                          {
                            isDialogOpen_Time &&
                            <ul
                              className={" iti__party-list iti__party-list--dropup"}
                              id="country-listbox"
                              aria-expanded="false"
                              role="listbox"
                              aria-activedescendant="iti-item-ad"
                            >
                              {getTimeSlotList()}
                            </ul>
                          }
                        </div>
                      </div>
                    )}
                    {businessSetting.SateOfSupply == 1 && (
                      <div className="form-group row">
                        <label
                          style={{ textAlign: "right" }}
                          className="col-lg-4 col-form-label"
                          htmlFor="val-username"
                        >
                          State of Supply
                        </label>
                        <div
                          className="col-lg-8 form-material"
                          id="paddingOff"
                        >
                          <select
                            className="form-control "
                            id="countryState"
                            name="countryState"
                            value={stateName}
                            disabled={isDuplicate}
                            onChange={(e) => setStateName(e.target.value)}
                          >
                            <option value=""> None</option>
                            {stateArray.map((item, index) => {
                              return (
                                <option
                                  key={index}
                                  value={item.name}
                                >
                                  {item.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    )}

                    <div className="form-material open"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* table page */} 
          {
            invoiceArray.length > 0 &&
            <QuickTransactionSaleInvoiceSection
                    invoiceArray={invoiceArray}
                    selectedInvoice={selectedInvoice}
                    isEditMode={isEditMode}
                    isMakePayment={isMakePayment}
                    isDuplicate={isDuplicate}
                    transactionType={2}
                    _businessSetting={businessSetting}
                    callBackItem={(selectedInvoice, _totalAmount) => callBack(selectedInvoice, _totalAmount)}
                />
          }
          {/* table page */}
          {
            (invoiceArray.length > 0 && selectedInvoice.length > 0) &&
            <div className="row">
              <div className="col-md-6">
                <div className="block block-transparent">
                  <div className="block-content" id="formSideLeft">
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="form-material open" id="paddingOff">
                          <select
                            className="col-8 form-control"
                            value={bankId}
                            onChange={(e) => selectBank(e)}
                            disabled={isDuplicate}
                          >
                            {
                              bankArray.map((bankD, index) => {
                                return (
                                  <option
                                    key={index}
                                    value={bankD.id}
                                  >
                                    {bankD.bank_name ? bankD.bank_name : bankD.display_name}
                                  </option>
                                )
                              })
                            }
                          </select>
                        </div>
                        {paymentType != "Cash" && (
                          <div className="form-material open">
                            <div
                              className="col-8 form-material"
                              id="paddingOff"
                            >
                              <input
                                type="text"
                                className="form-control"
                                value={paymentRefNo}
                                required="required"
                                onChange={(e) => setPaymentRefNo(e.target.value)}
                                placeholder="Enter Reference No.."
                                autoComplete="off"
                                maxLength={30}
                                disabled={isDuplicate}
                              />
                            </div>
                          </div>
                        )}
                        <div className="form-material open">
                          <div className="col-12 form-material" id="paddingOff">
                            <input
                              type="text"
                              className="form-control"
                              required="required"
                              onChange={(e) => setDescription(e.target.value)}
                              placeholder="Enter a description"
                              autoComplete="off"
                              value={description}
                              disabled={isDuplicate}
                            />
                          </div>
                        </div>
                        <div className="form-material open">
                          <div className="col-10 form-material" id="paddingOff">
                            <input
                              ref={refDescImage}
                              type="file"
                              accept="image/*"
                              style={{ width: "60%", display: "inline-block" }}
                              autoComplete="false"
                              className="form-control"
                              id="descImage"
                              name="descImage"
                                disabled={isDuplicate}
                              onChange={(e) => onChangeFileUploadHandler(e)}
                            />
                            {previewImagesListing()}
                          </div>
                        </div>

                        {businessSetting.PrintOriginalDuplicate == 1 && (
                          <div className="form-material open">
                            <label
                              style={{ textAlign: "right", position: "static" }}
                              className="col-form-label"
                              htmlFor="totalAmount"
                            >
                              Original / Duplicate Setting
                            </label>
                            <div
                              className="col-8 form-material"
                              id="paddingOff"
                            >
                              <select
                                className="col-8 form-control"
                                onChange={(e) => setPrintType(e.target.value)}
                                value={printType}
                                disabled={isDuplicate}
                              >
                                {printTypeList.map(({ value, label }, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={value}
                                    >
                                      {label}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="block block-transparent">
                  <div className="block-content">
                    <div id="taxDisData">
                      <div className="col-md-12" id="formSideRight">
                        <div className="row">
                          <label
                            style={{
                              textAlign: "right",
                              margin: "25px 0 0 0",
                            }}
                            className="col-lg-4 col-form-label"
                          >
                            Transaction Tax Amount
                          </label>
                          <div
                            className="col-lg-4 form-material"
                            style={{
                              padding: "0 !important",
                              margin: "0 !important",
                            }}
                          >
                            <input
                              type="text"
                              className={"form-control"}
                              autoComplete="off"
                              value={totalTransTaxAmount}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      
                      
                      {/*Additional Charges */}
                      {businessSetting.TransactionAdditionalChargeEnable ==
                        1 && (
                          <div id="taxDisData">
                            {businessSetting.TransactionAdditionalCharge1Enable ==
                              1 && (
                                <div className="col-md-12" id="formSideRight">
                                  <div className="form-group row">
                                    <label
                                      style={{ textAlign: "right" }}
                                      className="col-lg-4 col-form-label"
                                      htmlFor="TransAdditionalCharge1"
                                    >
                                      {
                                        businessSetting.TransactionAdditionalCharge1Name
                                      }
                                    </label>
                                    <div
                                      className="col-lg-8 form-material"
                                      id="paddingOff"
                                    >
                                      <input
                                        type="text"
                                        className="form-control"
                                        onKeyPress={(e) => handleKeyPress(e)}
                                        onChange={(e) => onChangeAdditionalCharge1(e.target.value)}
                                        placeholder=""
                                        value={transAdditionalCharge1}
                                        autoComplete="off"
                                        disabled={isDuplicate}
                                        readOnly
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}

                            {businessSetting.TransactionAdditionalCharge2Enable ==
                              1 && (
                                <div className="col-md-12" id="formSideRight">
                                  <div className="form-group row">
                                    <label
                                      style={{ textAlign: "right" }}
                                      className="col-lg-4 col-form-label"
                                      htmlFor="TransAdditionalCharge2"
                                    >
                                      {
                                        businessSetting.TransactionAdditionalCharge2Name
                                      }
                                    </label>
                                    <div
                                      className="col-lg-8 form-material"
                                      id="paddingOff"
                                    >
                                      <input
                                        type="text"
                                        onKeyPress={(e) => handleKeyPress(e)}
                                        onChange={(e) => onChangeAdditionalCharge2(e.target.value)}
                                        placeholder=""
                                        className="form-control"
                                        value={transAdditionalCharge2}
                                        autoComplete="off"
                                        style={{
                                          padding: "0 !important",
                                          margin: "0 !important",
                                        }}
                                        disabled={isDuplicate}
                                        readOnly
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}

                            {businessSetting.TransactionAdditionalCharge3Enable ==
                              1 && (
                                <div className="col-md-12" id="formSideRight">
                                  <div className="form-group row">
                                    <label
                                      style={{ textAlign: "right" }}
                                      className="col-lg-4 col-form-label"
                                      htmlFor="TransAdditionalCharge3"
                                    >
                                      {
                                        businessSetting.TransactionAdditionalCharge3Name
                                      }
                                    </label>
                                    <div
                                      className="col-lg-8 form-material"
                                      id="paddingOff"
                                    >
                                      <input
                                        type="text"
                                        className="form-control"
                                        onKeyPress={(e) => handleKeyPress(e)}
                                        onChange={(e) => onChangeAdditionalCharge3(e.target.value)}
                                        placeholder=""
                                        value={transAdditionalCharge3}
                                        autoComplete="off"
                                        disabled={isDuplicate}
                                        readOnly
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                        )}
                      {/*End Additional Charges */}
                    </div>

                    <div className="col-md-12" id="formSideRight">
                      {
                        reverseChargeStatus &&
                        <div className="form-group row">
                          <label
                            style={{ textAlign: "right" }}
                            className="col-lg-4 col-form-label"
                          >
                            Reverse Charge Tax
                          </label>
                          <div className="col-lg-8 form-material" id="paddingOff">
                            <input
                              type="text"
                              readOnly="readOnly"
                              className="form-control"
                              placeholder=""
                              value={reverseChargeTax}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      }
                      {
                        reverseChargeStatus &&
                        <div className="form-group row">
                        <label
                          style={{ textAlign: "right" }}
                          className="col-lg-4 col-form-label"
                        >
                          Payable Amount
                        </label>
                        <div className="col-lg-8 form-material" id="paddingOff">
                          <input
                            type="text"
                            readOnly="readOnly"
                            className="form-control"
                            placeholder=""
                            value={payableAmount}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      }
                      <div className="form-group row">
                        <label
                          style={{ textAlign: "right" }}
                          className="col-lg-4 col-form-label"
                          htmlFor="totalAmount"
                        >
                          Total Amount
                        </label>
                        <div className="col-lg-8 form-material" id="paddingOff">
                          <input
                            type="text"
                            readOnly="readOnly"
                            className="form-control"
                            placeholder=""
                            value={totalAmount}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div >
                        <div className="form-group row">
                          <label
                            style={{ textAlign: "right" }}
                            className="col-lg-4 col-form-label"
                          >
                            Received Amount
                          </label>
                          <div
                            className="col-lg-8 form-material"
                            id="paddingOff"
                          >

                            <input
                              type="text"
                              className="form-control"
                              onKeyPress={(e) => handleKeyPress(e)}
                              placeholder=""
                              value={receivedAmount}
                              onChange={(e) => onChangeReceivedAmount(e.target.value)}
                              autoComplete="off"
                              onWheel={() => document.activeElement.blur()}
                              disabled={isDuplicate}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            style={{ textAlign: "right" }}
                            className="col-lg-4 col-form-label"
                            htmlFor="dueAmount"
                          >
                            Balance Due
                          </label>
                          <div
                            className="col-lg-8 form-material"
                            id="paddingOff"
                          >
                            <input
                              type="text"
                              readOnly="readOnly"
                              className="form-control"
                              id="dueAmount"
                              name="dueAmount"
                              placeholder=""
                              value={dueAmount}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>

                      <div id="additionFields">
                        {(businessSetting.additional_field_check1 == 1) && (
                          <div className="form-group row">
                            <label
                              style={{ textAlign: "right" }}
                              className="col-lg-4 col-form-label"
                              htmlFor="addF1"
                            >
                              {businessSetting.additional_field_name1}
                            </label>
                            <div
                              className="col-lg-8 form-material"
                              id="paddingOff"
                            >
                              <input
                                type="text"
                                className="form-control"
                                id="additional_value_1"
                                name="additional_value_1"
                                placeholder=""
                                value={additionalValue1}
                                autoComplete="off"
                                disabled={isDuplicate}
                                onChange={(e) => setAdditionalValue1(e.target.value)}
                              />
                            </div>
                          </div>
                        )}

                        {(businessSetting.additional_field_check2 == 1 ||
                          businessSetting.additional_field_check2 ===
                          true) && (
                            <div className="form-group row">
                              <label
                                style={{ textAlign: "right" }}
                                className="col-lg-4 col-form-label"
                                htmlFor="addF2"
                              >
                                {businessSetting.additional_field_name2}
                              </label>
                              <div
                                className="col-lg-8 form-material"
                                id="paddingOff"
                              >
                                <input
                                  type="text"
                                  className="form-control"
                                  id="additional_value_2"
                                  name="additional_value_2"
                                  placeholder=""
                                  value={additionalValue2}
                                  autoComplete="off"
                                disabled={isDuplicate}
                                  onChange={(e) => setAdditionalValue2(e.target.value)}
                                />
                              </div>
                            </div>
                          )}

                        {(businessSetting.additional_field_check3 == 1 ||
                          businessSetting.additional_field_check3 ===
                          true) && (
                            <div className="form-group row">
                              <label
                                style={{ textAlign: "right" }}
                                className="col-lg-4 col-form-label"
                                htmlFor="addF3"
                              >
                                {businessSetting.additional_field_name3}
                              </label>
                              <div
                                className="col-lg-8 form-material"
                                id="paddingOff"
                              >
                                <input
                                  type="text"
                                  className="form-control"
                                  id="additional_value_3"
                                  name="additional_value_3"
                                  placeholder=""
                                  value={additionalValue3}
                                  autoComplete="off"
                                disabled={isDuplicate}
                                  onChange={(e) => setAdditionalValue3(e.target.value)}
                                />
                              </div>
                            </div>
                          )}
                        {(businessSetting.additional_field_date_field_check ===
                          1 ||
                          businessSetting.additional_field_date_field_check ===
                          true) && (
                            <div className="form-group row">
                              <label
                                style={{ textAlign: "right" }}
                                className="col-lg-4 col-form-label"
                                htmlFor="addFDate"
                              >
                                {
                                  businessSetting.additional_field_date_field_name
                                }
                              </label>
                              <div
                                className="col-lg-8 form-material"
                                id="paddingOff"
                              >
                                {viewAdditionalDate()}
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {businessSetting.TransportationDetailsField1Enable == 1 && (
                // Transportation Detail Here
                // <QuickTransportationDetails />
                <div className="col-md-12">
                  <div className="block block-transparent">
                    <div className="block-content">
                      <h5 className="content-heading">
                        Transportation Details
                      </h5>
                      <div className="block">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="block block-transparent">
                              <div className="block-content" id="formSideLeft">
                                <div className="form-group row">
                                  {businessSetting.TransportationDetailsField1Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField1Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField1"
                                            id="TransportDetailField1"
                                            value={transportDetailField1}
                                            disabled={isDuplicate}
                                            onChange={(e) => setTransportDetailField1(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField1Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  {businessSetting.TransportationDetailsField2Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField2Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField2"
                                            id="TransportDetailField2"
                                            value={
                                              transportDetailField2
                                            }
                                            disabled={isDuplicate}
                                            onChange={(e) => setTransportDetailField2(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField2Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  {businessSetting.TransportationDetailsField3Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField3Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField3"
                                            id="TransportDetailField3"
                                            value={
                                              transportDetailField3
                                            }
                                            disabled={isDuplicate}
                                            onChange={(e) => setTransportDetailField3(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField3Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  {businessSetting.TransportationDetailsField4Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField4Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField4"
                                            id="TransportDetailField4"
                                            value={
                                              transportDetailField4
                                            }
                                            disabled={isDuplicate}
                                            onChange={(e) => setTransportDetailField4(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField4Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  {businessSetting.TransportationDetailsField5Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField5Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField5"
                                            id="TransportDetailField5"
                                            value={
                                              transportDetailField5
                                            }
                                            disabled={isDuplicate}
                                            onChange={(e) => setTransportDetailField5(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField5Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  {businessSetting.TransportationDetailsField6Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField6Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField6"
                                            id="TransportDetailField6"
                                            value={
                                              transportDetailField6
                                            }
                                            disabled={isDuplicate}
                                            onChange={(e) => setTransportDetailField6(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField6Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="col-md-12">
                <div className="row justify-content-center text-right">
                  <div className="col-lg-9">
                    <button
                      type="submit"
                      onClick={() => clickToAddPurchaseReturn()}
                      className="btn btn-alt-primary mb-10 mx-5"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <><i className="fa fa-spinner fa-spin mr-5"></i> Saving...</>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }

        </div>
      </div>
     
      {
        isDialogOpen_AddPrefix && (
          <Dialog width={500} title={'Add New Prefix'} onClose={() => setIsDialogOpen_AddPrefix(false)}>
            <QuickAddNewPrefix
              callBack={(newPrefixId, newPrefixName) => onCallbackAddPrefix(newPrefixId, newPrefixName)}
              transactionType="DEBIT NOTE"
            />

          </Dialog>
        )
      }
      {
          isDialogAddNewParty && (
              <Dialog width={'50%'} height={600}  title={'Add New Party'} onClose={() => setIsDialogAddNewPArty(false)}>
  
                  <QuickAddNewParty isRedirectTo={"business/add-purchase/"} />
  
              </Dialog>
          )
      }
      {
        isDialogAddNewBank && (
            <Dialog  width={'70%'}  title={'Add New Bank'} onClose={() => setIsDialogAddNewBank(false)}>

                <QuickAddNewBankDetail
                  callBack={() => {
                    getBankListData(companyId);
                    setIsDialogAddNewBank(false);
                  }} />

            </Dialog>
        )
      }
      {
        isDialogPreviewImage && (
          <Dialog width={'70%'} height={'70%'} title={'Preview'} onClose={() => setIsDialogPreviewImage(false)}>
              <img
                style={{
                  width: "100%", 
                  height: "100%", 
                  objectFit: "contain"
                }}
                className="preview"
                src={imagePreviewUrl}
                alt={"image-"}
                key="13213"
              />

          </Dialog>
        )
      }

      {
        isLoading && (
          <Dialog >
            <Loader type="converging-spinner" />
          </Dialog>
        )
      }
      {
        showSuccessDialog &&
        <TransactionCreateDialog
          onPreview={() => {
            setShowSuccessDialog(false);
            window.location.href = global.webUrl + "business/purchaseReturnPdfDialog/?new=true&auth=" + transactionId;
          }}
          closeText={isEditMode ? 'Re Edit' : 'Add More'}
          onClose={() => {
            window.location.reload();
          }}
          onBack={() => {
            history.goBack();
          }}
          title={'Success'}
          message={message}
        />
      }

    </div>
  );
}
export default ManagePurchaseReturnCreate